import { Router } from 'vue-router';

export const redirectToDetails = (router: Router, id: string | number, targetRouteName: string): void => {
  let routeName = targetRouteName;
  const mainRouteName = targetRouteName.split('.')[0] ?? routeName;

  // If you're on a specific sub-route (tab), and click on another item
  // in the table, open the same tab for that new item.
  if (router.currentRoute.value.name !== mainRouteName) {
    routeName = router.currentRoute.value.name?.toString() || routeName;
  }

  router.push({
    name: routeName,
    params: { id }
  });
};
